"use strict";

var LoggerInstance = require("js-logger").get("MyPledgesHelper");

var AbstractPledgeManagementHelper = require("./AbstractPledgeManagementHelper");
var AccountStore = require("./AccountStore");

var Spinner = require("../client/Spinner");

var AccountApi = require("../api/AccountApi");

var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");

var WizardConstants = require("../constants/WizardConstants");

var BootstrapPrompt = require("../shared/BootstrapPrompt");
var HtmlHelper = require("../shared/HtmlHelper");

var MyPledgesHelper = class extends AbstractPledgeManagementHelper {
	constructor() {
		var singlePledgeEditComponentName = "myPledges.populated.singlePledge.edit";
		var donateToAllCheckboxComponentName = "myPledgesDonateToAll";
		var donateToSingleCheckboxComponentName = "myPledgesDonateToSingle";

		super({
			cancelPledgeEditLinkMessageMapper: "cancelMyPledgeEdit",
			cancelWholePledgeLinkMessageMapper: "cancelMyPledge",
			componentSelector: "[data-component='myPledges']",
			displayMessagesWizard: "wizardMyPledgesDisplayMessages",
			donateToAllCheckboxComponentName,
			donateToAllCheckboxSelector: `input[data-component="${donateToAllCheckboxComponentName}"]`,
			donateToSingleCheckboxComponentName,
			donateToSingleCheckboxSelector: `input[data-component="${donateToSingleCheckboxComponentName}"]`,
			editMyPledgeLinkMessageMapper: "editMyPledge",
			makeDonationSelector: "[data-component='myPledgesMakeDonation']",
			myRecurringPopulatedSingleRecurringSelector: "[data-component='myRecurring.populated.singleRecurring']",
			myRecurringSelector: "[data-component='myRecurring']",
			singlePledgeEditComponentName,
			singlePledgeSelector: "[data-component='myPledges.populated.singlePledge']",
			singlePledgeEditSelector: `[data-component='${singlePledgeEditComponentName}']`,
			singlePledgeEditAmountSelector: "[data-component='myPledges.populated.singlePledge.edit.amount']"
		});
	}

	getMyPledgeHtml(event, isEditing, newPledgeId) {
		return this.getComponentHtml(event, newPledgeId, ($currentPledge, pledgeId, componentId, deferred) => {
			AccountApi.myPledgeGet(pledgeId, componentId, isEditing, /*sponsorshipType*/ "NONE").done((data) => {
				var $data = $(data);

				var $newEditForm = $data.find("form#editMyPledge");
				var newId = $newEditForm.attr("id") + "-" + $data.closest("[data-component='myPledges.populated.singlePledge']").attr("data-pledge-id");
				HtmlHelper.setUniqueFormId($newEditForm, newId);

				$currentPledge.replaceWith($data);
				if (isEditing) {
					this.initializeEdit($data);
					HtmlHelper.focusAndSelectFirstField($data);
				} else {
					this.initializeComponent($data);
				}

				deferred.resolve($data);
			}).fail((jqXHR, textStatus) => {
				this._resolveError(jqXHR, textStatus, deferred);
			});
		});
	}

	cancelMyPledgeEdit(event) {
		return super.cancelPledgeEdit(event, ($currentPledge) => {
			this.getMyPledgeHtml(event, /*isEditing*/false, null)
				.always(() => Spinner.removeSpinner($currentPledge));
		});
	}

	cancelWholePledge(event) {
		return super.cancelWholePledge(event, ($currentPledge, pledgeId) => {
			//Call API to delete
			AccountApi.myPledgesCancel(pledgeId, /*sponsorshipType*/ "NONE").done((data) => {
				var $pledges = $currentPledge.closest("[data-component='myPledges']");

				if ((data || {}).refresh || $pledges.find("[data-component='myPledges.populated.singlePledge']").length <= 1) {
					//If we canceled the last pledge or canceled a pledge with a recurring, we want to reload the entire page
					window.location.reload();
				} else {
					HtmlHelper.deleteChildOfColumnAndPromoteColumnChildren($currentPledge);
					Spinner.removeSpinner();
				}
			}).fail((jqXHR, textStatus) => {
				this._resolveError(jqXHR, textStatus);
				Spinner.removeSpinner();
			});
		});
	}

	editMyPledge(event) {
		return super.editPledge(event, ($currentPledge) => {
			this.getMyPledgeHtml(event, /*isEditing*/true, null)
				.always(() => Spinner.removeSpinner($currentPledge));
		});
	}

	makeDonation(event, isDesignMode) {
		return super.makeDonation(event, isDesignMode, (pledgeIds) => {
			AccountApi.myPledgesMakeDonation({ pledgeIds }, /*sponsorshipType*/ "NONE").done((response) => {
				window.location = "/shoppingcart";
			}).fail(() => {
				BootstrapPrompt.alert(AccountStore.getWizardValue(
					WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES,
					WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
					{ tangibleType: "donation(s)" }
				));
				Spinner.removeSpinner();
			});
		});
	}

	initializeMyPledges($component, isDesignMode) {
		super.initializeComponent($component, isDesignMode);
	}

	initializeMyPledgesEdit($component) {
		super.initializeEdit($component);
	}

	saveMyPledge(event) {
		return super.save(event, ($currentPledge, pledgeId, componentId, editPledgeData) => {
			//Call API to edit
			AccountApi.myPledgesEdit(pledgeId, componentId, editPledgeData, /*sponsorshipType*/ "NONE").done((data) => {
				var actionData = SubmitButtonHelper.getPostSubmitActionData(`[data-component='${this.singlePledgeEditComponentName}']`);
				var $data = $(data);

				$currentPledge.replaceWith($data);
				this.initializeMyPledges($data);
				HtmlHelper.focusAndSelectFirstField($data);

				this._refreshAssociatedRecurringHtml(pledgeId).done(() => Spinner.removeSpinner());

				SubmitButtonHelper.performPostSubmitAction(
					`[data-component='${this.singlePledgeEditComponentName}']`,
					{ actionData }
				);
			}).fail((jqXHR, textStatus) => {
				this._resolveError(jqXHR, textStatus);
				Spinner.removeSpinner();
			});
		});
	}
};

module.exports = new MyPledgesHelper();


// WEBPACK FOOTER //
// ./Javascript/accountComponents/MyPledgesHelper.jsx